export const setReturnTo = returnTo => ({
  type: 'SET_RETURN_TO',
  returnTo: returnTo
})
